import { Pipe, PipeTransform } from '@angular/core';
import { EmailFrom } from '../models/EmailFrom';

@Pipe({
  name: 'EmailFrom',
})
export class EmailFromPipe implements PipeTransform {
  transform(emailFromId: string, emailfromList: EmailFrom[]): any {
    if (
      emailFromId == null ||
      emailFromId === '' ||
      emailfromList.length === 0
    ) {
      return '';
    }

    const emailFrom = emailfromList.find((x) => x.id === emailFromId);
    return `${emailFrom.displayName} - ${emailFrom.sender.protocol} - ${emailFrom.sender.userName}`;
  }
}
